<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" lg="6">
        <grid :items="applications" mode="application" :cols="6" />
      </v-col>
      <v-col cols="12" lg="6">
        <grid :items="agents" mode="agent" :cols="6" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Grid from "@/components/grid"
import Agents from "@/api/agents"
import Applications from "@/api/applications"
export default {
  name: "Home",
  components: { Grid },
  data() {
    return {
      agents: [],
      applications: [],
    }
  },
  mounted() {
    Agents.list().then(response => this.agents = response.data)
    Applications.list().then(response => this.applications = response.data)
  }
}
</script>
